module.exports = __webpack_public_path__ + "img/visa.02c1adc3.svg";